import { Link } from "react-router-dom";

export default function FeaturedArticle() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="w-full lg:w-5/12">
            <div className="rounded-2xl overflow-hidden h-72 md:h-full min-h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20spreadsheet%20concept%20with%20clothing%20items%20and%20checklist%20on%20light%20blush%20pink%20textured%20surface%2C%20editorial%20photography%2C%20soft%20natural%20daylight%2C%20organized%20clean%20composition%2C%20modern%20buying%20guide%20theme&width=700&height=900&seq=featured-v2-article&orientation=portrait"
                alt="Best AcBuy Spreadsheet 2026 buying guide"
                title="AcBuy Spreadsheet 2026 Ultimate Guide"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-7/12 flex flex-col justify-center">
            <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
              Featured Guide
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              Best AcBuy Spreadsheet 2026
            </h2>
            <p className="text-xl md:text-2xl font-heading italic text-foreground-500 mb-6">
              Ultimate Buying Guide
            </p>
            <blockquote className="border-l-4 border-accent-400 pl-5 mb-6">
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                This comprehensive 3,000+ word guide covers everything you need to know about using AcBuy spreadsheets in 2026. From finding trusted sellers across all 14 categories — Shoes, Hoodies, T-Shirts, Jackets, Bags, and more — to mastering shipping logistics and safety best practices. Whether you are a complete beginner or an experienced buyer, this guide walks you through every step of discovering the best fashion finds with confidence.
              </p>
            </blockquote>
            <p className="text-sm font-semibold text-foreground-800 mb-6">
              — AcBuySpreadsheet Editorial Team
            </p>
            <Link
              to="/article/acbuy-spreadsheet-guide-2026"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer w-fit"
            >
              Read Full Guide
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}